module.exports = __webpack_public_path__ + "static/img/scene1.bd52468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene1.png
// module id = 7qIe
// module chunks = 1